// extracted by mini-css-extract-plugin
export default {"products":"iB-z","card":"jB-z","oosMessaging":"kB-z"};